/*! @azure/msal-react v2.2.0 2024-11-05 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "2.2.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
